export const createAvatar = (name) => {
  if (!name) return "UN";
  const parts = name.split(" ");
  return ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase();
};
